import React, { useEffect, useMemo, useRef, useState } from "react";
import { USER_DATA, CM_LOGO } from "../constants";
import { SELECTED_HOTEL_ID, SELECTED_HOTEL_NAME } from "../constants";
import { useDispatch } from "react-redux";
import { Popup } from "semantic-ui-react"
import { isMobile } from "react-device-detect";

function HotelsDropDown(props) {
  let hotelsRef = useRef();
  const [hotelValueText, setHotelValueText] = useState("");
  const [hotelsDropdown, setHotelsDropdown] = useState(false);
  const [listVisible, setListVisible] = useState(false);

  const [hotelName, setHotelName] = useState(
    localStorage.getItem(SELECTED_HOTEL_NAME)
  );

  // Prefer the live auth response from redux so newly linked hotels appear
  // immediately; localStorage is only the fallback before the session loads.
  const hotelsList = useMemo(() => {
    const data =
      props.session && props.session.data && props.session.data.hotels
        ? props.session.data
        : JSON.parse(localStorage.getItem(USER_DATA));
    return data ? data.hotels : [];
  }, [props.session && props.session.data && props.session.data.hotels]);

  const filteredHotels = useMemo(() =>
    hotelsList.filter(option =>
      option.hotel_name.toLowerCase().includes(hotelValueText.toLowerCase())
    ),
    [hotelsList, hotelValueText]
  );

  const dispatch = useDispatch()

  useEffect(() => {
    if (!listVisible) return;
    const el = document.getElementById("hotelsDivBlock");
    if (el) {
      const selected = document.getElementById(localStorage.getItem(SELECTED_HOTEL_ID));
      if (selected) el.scrollTo(0, selected.offsetTop - 150);
    }
    onFocusInputFeild();
  }, [listVisible]);

  useEffect(() => {
    let handler = (e) => {
      if (hotelsDropdown) {
        if (!hotelsRef.current.contains(e.target)) {
          setHotelsDropdown(false);
          setListVisible(false);
          setHotelValueText("");
        }
      }
    };

    document.addEventListener("mousedown", handler);

    return () => {
      document.removeEventListener("mousedown", handler);
    };
  });

  const handleHotelsDropdown = () => {
    if (hotelsDropdown) {
      setHotelsDropdown(false);
      setListVisible(false);
      setHotelValueText("");
    } else {
      setHotelsDropdown(true);
      setHotelValueText("");
      // wait for container to paint before rendering the full hotel list
      requestAnimationFrame(() => requestAnimationFrame(() => setListVisible(true)));
    }
  };

  const onHandleHotelSearchInput = (event) => {
    setHotelValueText(event.target.value);
  };

  const onSelectHotel = (option) => {
    if (option.hotel_id !== localStorage.getItem(SELECTED_HOTEL_ID)) {

      setHotelValueText("");
      setHotelName(option.hotel_name);
      setHotelsDropdown(false);
      setListVisible(false);

      props.session.selectedHotelID = option.hotel_id;
      props.session.selectedHotelName = option.hotel_name;

      let selectedHotel = hotelsList.find(
        (hotel) => hotel.hotel_id === option.hotel_id
      );

      if (!selectedHotel) return;

      localStorage.setItem(SELECTED_HOTEL_ID, selectedHotel.hotel_id);
      localStorage.setItem(SELECTED_HOTEL_NAME, selectedHotel.hotel_name);

      if (selectedHotel.agreement_type === "DISPLAY") {
        props.history.push("/agreement");
      }
      else if (
        selectedHotel.agreement_type !== "DISPLAY" &&
        selectedHotel.allow_foreign_guest === "DISPLAY"
      ) {
        props.history.push("/foreign-guest");
      }
      else {
        {/* We cannont re route to the same route after changing the hotel*/ }
        props.history.push(props.history.location.pathname === "/" ? "/summary" : "/");
      }

      //Dispatching the actions to clear the previous hotel responses on redux store
      dispatch({ type: "clear_hotel_data_response" })
      dispatch({ type: "clear_soldOut_res" })
      dispatch({ type: "clear_finance_summary_res" })
      dispatch({ type: "clear_rooms_api_res" })
      dispatch({ type: "clear_brevi_bookings_res" })
      dispatch({ type: "clear_holida_bookings_res" })
    }

  };

  const onFocusInputFeild = () => {
    document.getElementById("hotelInputFeild").focus()
  }


  return (
    isMobile ?
      <MobileViewHotelsDropDown />
      :
      <div
        ref={hotelsRef}
        className={`hotelsDropDown ${hotelsDropdown ? "open" : ""}`}
        style={{
          cursor: "pointer",
          paddingInline: 15,
          zIndex: 20,
        }}
        onClick={() => !hotelsDropdown && handleHotelsDropdown()}

      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            width: "100%",
          }}
        >
          <div style={{ width: "95%" }}>
            {!hotelsDropdown ?
              (
                <div
                  style={{ width: "100%", display: "flex", alignItems: "center" }}
                >
                  <input
                    autoComplete="off"
                    className="hotelNameTxt"
                    value={
                      hotelName === "" ? "Select Hotel" : hotelName
                    }
                    style={{
                      color: "#000000",
                      fontFamily: "Poppins",
                      width: "100%",
                      fontWeight: 400,
                      paddingLeft: 15,
                      borderWidth: 0,
                      borderStyle: "none",
                      outline: "none",
                    }}
                  />
                </div>
              )
              :
              (
                <div
                  style={{ width: "100%", display: "flex", alignItems: "center" }}
                >
                  <svg
                    onClick={() => onFocusInputFeild()}
                    className="search_icon_svg"
                    viewBox="0 0 32 32"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle
                      cx="14.666"
                      cy="14.6666"
                      r="7.33333"
                      stroke="#9B97A0"
                      strokeWidth="1.33333"
                    />
                    <path
                      d="M20 20L25.6569 25.6569"
                      stroke="#9B97A0"
                      strokeWidth="1.33333"
                      strokeLinecap="round"
                    />
                  </svg>

                  <input
                    placeholder={
                      hotelName === "" ? "Search" : hotelName
                    }
                    autoComplete="off"
                    value={hotelValueText}
                    onChange={(event) => onHandleHotelSearchInput(event)}
                    className="hotelNameTxt"
                    style={{
                      height: "100%",
                      width: "100%",
                      borderWidth: 0,
                      borderStyle: "none",
                      outline: "none",
                      marginLeft: "1rem",
                      backgroundColor: "transparent",
                    }}
                    id="hotelInputFeild"
                  />
                </div>
              )}
          </div>

          <div
            className={`hotelDropDownIcon ${hotelsDropdown ? "open" : ""
              }`}
            onClick={() => handleHotelsDropdown()}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="arrow_icon_svg"
              viewBox="0 0 15 11"
              fill="none"
            >
              <path
                d="M6.71285 9.99541C7.11323 10.5064 7.88677 10.5064 8.28715 9.99541L14.4604 2.11677C14.9747 1.46043 14.5071 0.5 13.6733 0.5H1.32672C0.49291 0.5 0.025305 1.46044 0.53957 2.11677L6.71285 9.99541Z"
                fill="#000000"
              />
            </svg>
          </div>
        </div>

        {hotelsDropdown && (
          <div className="hotelsOuterCls" id="hotelsDivBlock">
            {!listVisible
              ? <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: "100%", height: "100%" }}>
                  <p className="hotels_txt_value" style={{ color: "#9B97A0" }}>Loading...</p>
                </div>
              : filteredHotels.length > 0
                ? filteredHotels.map((option) => (
                    <div
                      onClick={() => onSelectHotel(option)}
                      style={{ backgroundColor: hotelName === option.hotel_name ? "#F6F2FF" : "" }}
                      className="hotelOptions"
                      key={option.hotel_id}
                      id={option.hotel_id}
                    >
                      <span className="hotels_txt_value" style={{ paddingLeft: 10, fontWeight: hotelName === option.hotel_name ? "600" : "500" }}>
                        {option.hotel_name}
                      </span>

                      {option.active_channel_manager === "1" &&
                        <Popup
                          trigger={
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                              <img
                                src={CM_LOGO[option.active_channel_manager_name] || ""}
                                style={{ width: '1.25rem', height: '1.25rem', borderRadius: "1rem" }}
                              />
                              <p className="__staahTag">
                                {option.active_channel_manager_name}
                              </p>
                            </div>
                          }
                          content='Channel Manager'
                          position='top center'
                        />
                      }
                    </div>
                  ))
                : <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: "100%", height: "100%" }}>
                    <p className="hotels_txt_value">No Results...</p>
                  </div>
            }
          </div>
        )}
      </div>

  );
}

export default HotelsDropDown;


const MobileViewHotelsDropDown = (props) => {
  return (
    <div style={{margin:"1rem",width:"100%"}}>
      <input  style={{width:"100%"}}/>
    </div>
  )
}